import React from "react";
import {
  NavLink,
} from "react-router-dom";
import { Socials } from "../composites/Socials";

import bubonic from "../../resources/images/BUBO/BLOOD_official.png";
import nofs from "../../resources/images/projects/NOFS_pumpkin.gif";
import tune from "../../resources/images/projects/TUNE_card.png";
import kid from "../../resources/images/splash/idleGhostKid.gif";

import needle from "../../resources/images/splash/needle.gif";
import potion from "../../resources/images/splash/potion.gif";

export function Splash(): React.ReactElement {
  return(
    <div className="splash-page container">
      <div className="title" >
        Welcome to the world of Twisted Tech productions!
      </div>
      <div className="main-projects">
        <div className="nav-div"> 
          <img
            className="project-image"
            id="bubonic"
            alt="bubonic-icon"
            src={bubonic}
          />
          <NavLink to={`/bubos/mint`} className="header-link-button bubos-link" >
            Bubonic Bastards
          </NavLink>
        </div>
        <div className="nav-div"> 
          <img
              className="project-image"
              id="nofs"
              alt="nofs-icon"
              src={nofs}
            />
          <NavLink to={`/nofs`} className="header-link-button nofs-link">
            Nightmare on Fantom St.
          </NavLink>
        </div>
      </div>
      <div className="sub-title">
        Checkout our launchpad projects too:
      </div>
      <div className="launchpad-projects">
        <div className="nav-div"> 
          <img
            className="project-image"
            id="tune"
            alt="tune-icon"
            src={tune}
          />
          <NavLink to={`/launchpad/tune`} className="header-link-button tune-link">
            Tune
          </NavLink>
        </div>
      </div>
      <img
          className="ghost-kid"
          id="ghost-kid"
          alt="ghost-kid"
          src={kid}
        />
      <img
        className="needle-gif"
        id="needle-gif"
        alt="needle-gif"
        src={needle}
        style={{
          zIndex: 100,
        }}
      /> 
      <img
        className="potion-gif"
        id="potion-gif"
        alt="potion-gif"
        src={potion}
        style={{
          zIndex: 100,
        }}
      /> 
      <div className="footer" >
        <div className="company">
          Twisted Tech
        </div>
        <Socials />
      </div>
    </div>
  )
}